import { defineComponent as _defineComponent } from 'vue'
import { TemplateProductVariant, Variant } from '@/api/typings/templateProducts';
import { GenericPodProduct } from '@/api/typings/podProviders';


export default /*#__PURE__*/_defineComponent({
  __name: 'VariantMatchAssigner',
  props: {
    templateProduct: null,
    selectedProduct: null,
    provider: null
  },
  emits: ['open-variant-matcher'],
  setup(__props: any, { emit }) {

const props = __props as {
    templateProduct: TemplateProductVariant;
    selectedProduct: GenericPodProduct;
    provider: string;
};





const removeVariantSelection = (variant: Variant) => {
    variant.podVariantId = undefined;
    variant.podVariantName = undefined;
};

const selectVariant = (variant: Variant, key: string) => {
    emit('open-variant-matcher', variant, key);
};

const copyFirstPriceToAll = () => {
    if (!props.templateProduct.variants.length) return;

    const firstPrice = props.templateProduct.variants[0]?.wholesalePrice;
    if (firstPrice === undefined || firstPrice === null) return;

    // Update all variants with the first price
    props.templateProduct.variants.forEach((variant, index) => {
        if (index > 0) {
            // Skip the first variant since it's the source
            variant.wholesalePrice = firstPrice;
        }
    });

    // Force Vue to re-render by triggering reactivity
    // This creates a new reference to the variants array, forcing Vue to update
    props.templateProduct.variants = [...props.templateProduct.variants];
};

return { __sfc: true,emit, props, removeVariantSelection, selectVariant, copyFirstPriceToAll }
}

})